import React, { memo, ReactElement } from 'react';

import FormItemWrapperProps from './FormItemWrapperProps';

const FormItemWrapper = ({ children }: FormItemWrapperProps): ReactElement => <>{children}</>;

export default memo(FormItemWrapper);
